import type { ApiV1DashboardActivitiesGet200ResponseActivitiesItem } from './apiV1DashboardActivitiesGet200ResponseActivitiesItem';

export interface ApiV1DashboardActivitiesGet200Response {
  activities?: ApiV1DashboardActivitiesGet200ResponseActivitiesItem[];
  message?: string;
  success: boolean;
}
